<template>
  <a-select
    filterable
    v-model="currentValue">
    <a-select-option
      v-for="item in options"
      :key="item.id"
      :value="item.id">
      {{ item.name }}
    </a-select-option>
  </a-select>
</template>

<script>
// import { _queryLotteryActivities } from '@/api/lotteryActivityApi'
import { _queryLookBookTopics } from '@/api/lookBookTopicApi';

export default {
  name: 'LotterySelect',
  props: {
    dictCode: String,
    value: String,
  },
  data() {
    return {
      form: {
        visible: false,
        data: {
          name: '',
        },
      },
      table: {
        data: [],
      },
      options: [],
      currentValue: this.value,
      currentGoodsName: '',
    };
  },
  watch: {
    currentValue(val) {
      this.$emit('input', val);
    },
    value(val) {
      this.currentValue = val;
    },
  },
  methods: {},
  async created() {
    const result = await _queryLookBookTopics({});
    this.options = result.content;
    console.log(result);
  },
};
</script>

<style scoped>
.goods-wrap {
  height: 400px;
  overflow-y: auto;
}

.goods-item {
  margin: 10px 5px;
  cursor: pointer;
}

.goods-item:hover {
  color: #00A8CC;
}

</style>
